import React from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/SingleFleet.css'

import GroupIcon from '@mui/icons-material/Group';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link, useLocation } from 'react-router-dom';

const SingleFleet = () => {

    let location = useLocation();
    console.log(location);

    return (
        <div className='singlefleet'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container '>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Our Fleet</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='singlefleet-content'>
                <div className='container'>
                    <div className='row my-5'>
                        <div className='col-lg-12 my-3'>
                            <div className='card bg-gr-crd '>
                                <div className='card-body pos-rel p-5 p-res-singlefleet'>
                                    <div className='row'>
                                        <div className='col-lg-12 mb-5 mb-mob-no-singlefleet'>
                                            <p className='clr-df f-20 f-pop-med'>Our Vehicle Detail</p>
                                            <p className='f-25 f-pop-med mt-2 mb-4'>{location.state.vehicile_type}</p>
                                            <div style={{
                                                backgroundImage: `url("${location.state.bg_img}")`}} className='bg-img-singlefleet mb-5'>

                                            </div>
                                            {/* style={{ backgroundImage: `url("${location.state.image}")` }} */}
                                            <div  className='single_merecedes_fleet'>
                                                    <img className='w-100' src={location.state.image}/>
                                            </div>
                                        </div>
                                        <div className='col-lg-12 mt-5 mt-mob-no-singlefleet'>
                                            <p className='mt-3 f-pop-med f-25 mb-4'>Description</p>
                                            <p className='f-pop-med f-13 lh-02'>
                                                {location.state.desc}
                                            </p>
                                            <p className='f-pop-med f-13 lh-02'>
                                                Our extensive fleet offers a full and flexible seating capacity for private parties large and small: a range of 4,6 and 8 seater vehicles are offered as standard, including provision for wheelchair access.
                                            </p>
                                            <p className='f-pop-med f-13 lh-02'>
                                                For the security and comfort of female passengers travelling alone we will on request, and whenever possible, provide female drivers. Advance notification of your requirements would be helpful in this regard
                                            </p>

                                            <p className='f-pop-med f-25 mt-5 mb-4'>Vehicle Space & Size</p>
                                            <div className='d-flex flex-wrap mb-5'>
                                                <span className='me-5'><GroupIcon className='me-2' /> 4 Passengers</span>
                                                <span className='me-5'><DeleteIcon className='me-2' /> 2 large Bags</span>
                                                <span className='me-5'><DeleteIcon className='me-2' /> 2 small Bags</span>
                                            </div>

                                        </div>
                                        <div className='col-lg-12 mt-2'>
                                            <Link to="/booking" className='link_ourfleet'>
                                                <button className='btn btn-danger form-control btn-booking-now-fleet f-pop-med f-17'>Booking Now</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default SingleFleet;